import React from 'react';
import { SubtitleStyled, SubtitleTextStyled } from './styles';

interface Props {
  text: React.ReactNode;
  className?: string;
}

const SubtitleWithLines: React.FC<Props> = ({ text, className }) => {
  return (
    <SubtitleStyled className={className}>
      {/* Span wrapper helps to show lines from both sides of subtitle */}
      <SubtitleTextStyled>{text}</SubtitleTextStyled>
    </SubtitleStyled>
  );
};

export default SubtitleWithLines;
